module.exports = __webpack_public_path__ + "static/img/4.b9e3ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/4.jpg
// module id = P1OL
// module chunks = 1